<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      :loading="importHandleLoading"
      :loading-text="importHandleLoadingText"
      size="normal">
    <template #header>
      <span>导入批次</span>
    </template>
    <template #content>
      <gj-upload
          template-url="/supply/storageCostBatch/downloadTemplate"
          :templateParams="downParams"
          container-type="application/x-www-form-urlencoded"
          @uploadAfter="uploadAfter"
          style="margin-bottom: 10px;"
      ></gj-upload>
      <gj-import-alert
          :rules="[
            '重复导入同个批次数据将覆盖原有的数据',
            '同一个批次号存在多条记录，以第一条记录为准',
          ]">
      </gj-import-alert>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, uploadMixin} from "@/minxins";
  import { storageCostBatchImport } from "@/api/finance";
  import BigNumber from 'bignumber.js';

  export default {
    name: "ImportBatch",
    mixins: [modalMixIn, uploadMixin],
    props: {
      downParams: {
        default: () => []
      },
      excludeId: {
        default: () => []
      },
    },
    data() {
      return {
        loading: false,
      }
    },
    methods: {
      // 上传成功后的回调
      uploadAfter(attId, data, uploadCb) {
        this.importHandleLoading = true;
        storageCostBatchImport(
          {attachmentId: attId},
          this.excludeId
        )
          .then((res) => {
            let successList = res.data.successList || []
            successList.forEach(item => {
              item.purchaseCost = this._.round(item.purchaseCost, 4);
              item.arrivalCost = this._.round(item.arrivalCost, 4);
              item.purchaseCostTotal = new BigNumber(item.purchaseCost).times(item.receiptQuantity).decimalPlaces(4) + '';
              item.arrivalCostTotal = new BigNumber(item.arrivalCost).times(item.receiptQuantity).decimalPlaces(4) + '';
            });
            this.$gjImportHandle(res, uploadCb);
          }).catch(() => {
            uploadCb('error')
          })
          .complete(() => this.importHandleLoading = false);
      }
    }
  }
</script>

<style scoped>

</style>











s